import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DataManipService } from '../../Services/data-manip.service';


declare var LeaderLine: any;


@Component({
  selector: 'app-trail-test',
  templateUrl: './trail-test.component.html',
  styleUrls: ['./trail-test.component.scss']
})

export class TrailtestComponent implements OnInit {
  @ViewChild('trailTestModel', { static: false }) public trailTestModel: ModalDirective;
  @ViewChild('finalReportModal', { static: false }) public finalReportModal: ModalDirective;


  @Input() trialTestObj: any = {};
  @Output('testFinish') testFinish = new EventEmitter();
  public randomArray = [];
  private randomObject: any = {};

  private masterAnswerSheetArray: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25];

  private UserCorrectAnswerArray = [];
  private audio = undefined;


  second = 0;
  minute = 0;
  hour = 0;
  time = 0;
  mode = 1;
  status = 0;
  timer_id;
  wrongCount = 0;
  private trailTestSequence = {
    roundOneDemo: [1, 2, 3, 4, 5],
    roundOne: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25],

    roundTwoDemo: [1, "A", 2, "B", 3, "C", 4, "D", 5, "E"],
    roundTwo: [1, "A", 2, "B", 3, "C", 4, "D", 5, "E", 6, "F", 7, "G", 8, "H", 9, "I", 10, "J", 11, "K", 12, "L"]
  }
  public trailTestObj = {
    roundOneDemoTime: 0,
    roundOneDemoTimeInMinSec: { minute: 0, second: 0 },
    roundOneDemoWrongCount: 0,

    roundOneTime: 0,
    roundOneTimeInMinSec: { minute: 0, second: 0 },
    roundOneWrongCount: 0,
    roundOneTestResult: "",

    roundTwoTime: 0,
    roundTwoWrongCount: 0,
    roundTwoTimeInMinSec: { minute: 0, second: 0 },

    roundTwoDemoTime: 0,
    roundTwoDemoWrongCount: 0,
    roundTwoDemoTimeInMinSec: { minute: 0, second: 0 },
    roundTwoTestResult: "",

    testConclusions: '',
    userAge: 0
  };
  popup = {
    msg: ''
  };
  compliedRounds = [];
  currentActiveRound = 1;
  title = 'Trail Test Round One Demo';
  
  constructor(public dataManipSrvc: DataManipService,) {

  }
  ngOnInit(): void {
    this.popup.msg = 'Do you want to start the test?'
// console.log('trialTestObj', this.trialTestObj);
    // this.trailTestSequence = this.trialTestObj['testpattern'];
    this.masterAnswerSheetArray = this.trailTestSequence['roundOneDemo']
    // this.masterAnswerSheetArray = [1, "A", 2, "B", 3, "C", 4, "D", 5, "E", 6, "F", 7, "G", 8, "H", 9, "I", 10, "J", 11, "K", 12, "L"];
    this.generateRandomIntWithinRange(this.masterAnswerSheetArray);

  }

  startTest() {
    if (this.currentActiveRound == 1) {
      this.masterAnswerSheetArray = this.trailTestSequence.roundOne;
      this.title = 'Trail Test Round One';
    } else {
      this.title = 'Trail Test Round Two';
      this.masterAnswerSheetArray = this.trailTestSequence.roundTwo;

    }
    this.generateRandomIntWithinRange(this.masterAnswerSheetArray);
    this.trailTestModel.hide();
    this.timer();
    this.start();
  }

  getRandomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  ngAfterViewInit(): void {
    //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    //Add 'implements AfterViewInit' to the class.
    this.audio = document.getElementById('beep-one');
    // this.trailTestModel.show();
    this.timer();
    this.start();
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.stop();
  }
  generateRandomIntWithinRange(masterAnsArray) {
    this.randomArray = [];
    this.UserCorrectAnswerArray = [];
    this.wrongCount = 0;
    let maxRows = 9 * 5;
    this.randomArray = Array(maxRows);
    let count = 0;
    let start = 0;
    let end = masterAnsArray.length;
    this.randomObject = {};
    const isMobileScreen = window.screen.width < 768;
    let MTmin = 0;
    let MTmax = 0;
    let MLmin = 0;
    let MLmax = 0;
    let TOPmin = 0;
    let TOPman = 0; 
// console.log('isMobileScreen',isMobileScreen);
    if (isMobileScreen) {
      maxRows = 6 * 6;
      MTmin = -5;
      MTmax = 10;
      MLmin = -5;
      MLmax = 12;
      TOPmin = -4;
      TOPman = 9;
    } else {
      MTmin = -17;
      MTmax = 25;
      MLmin = -13;
      MLmax = 20;
      TOPmin = -4;
      TOPman = 9;
    };
    this.randomArray = Array(maxRows);

    while (start < end) {
      const ind = this.getRandomIntFromInterval(0, maxRows);
      if (!Object.prototype.hasOwnProperty.call(this.randomObject, ind)) {

        this.randomArray[ind] = { value: masterAnsArray[start], ind, checked: false, marginTop: this.getRandomIntFromInterval(MTmin, MTmax), marginLeft: this.getRandomIntFromInterval(MLmin, MLmax), top: this.getRandomIntFromInterval(TOPmin, TOPman) };
        this.randomObject[ind] = masterAnsArray[start];
        start++
      }
      count++
    }

    // console.log(this.randomObject, this.randomArray, count);


  }
  checkValue(item) {
    const value: number = item.value;
    const masterInd = this.masterAnswerSheetArray.indexOf(value);
    let flag = true;
    if (masterInd > -1) {
      if (this.UserCorrectAnswerArray.length) {
        const ansInd = this.UserCorrectAnswerArray.length
        const lastAns = this.UserCorrectAnswerArray[ansInd - 1];
        const masterAns = this.masterAnswerSheetArray[masterInd - 1]
        if (lastAns == masterAns) {
          this.UserCorrectAnswerArray[ansInd] = value;
          if (this.UserCorrectAnswerArray.length == this.masterAnswerSheetArray.length) {
            item.active = 'active-last-box';
            this.stop();
            if (!this.trailTestObj.roundOneDemoTime) {
              this.trailTestObj.roundOneDemoTime = this.convertMinIntoSec(this.minute) + this.second;
              this.trailTestObj.roundOneDemoTimeInMinSec = { minute: this.minute, second: this.second }
              this.popup.msg = 'Start test';

              this.trailTestObj.roundOneDemoWrongCount = this.wrongCount;
              this.wrongCount = 0;

              this.masterAnswerSheetArray = this.trailTestSequence.roundOne;
              this.currentActiveRound = 1;
              // this.generateRandomIntWithinRange(this.masterAnswerSheetArray);
              this.trailTestModel.show();

            } else if (!this.trailTestObj.roundOneTime) {
              this.trailTestObj.roundOneTime = this.convertMinIntoSec(this.minute) + this.second;
              this.trailTestObj.roundOneTimeInMinSec = { minute: this.minute, second: this.second }
              this.trailTestObj.roundOneWrongCount = this.wrongCount;
              this.wrongCount = 0;
              // this.trailTestObj.roundOneTestResult = this.checkTrailTestScoringPart1(this.dataManipSrvc.age, this.trailTestObj.roundOneTime)
              this.timer();
              this.start();
              setTimeout(() => {
                this.title = 'Trail Test Round Two Demo';
                this.masterAnswerSheetArray = this.trailTestSequence.roundTwoDemo;
                this.generateRandomIntWithinRange(this.masterAnswerSheetArray);
              }, 1500)
              // this.trailTestModel.show();
            } else if (!this.trailTestObj.roundTwoDemoTime) {
              this.trailTestObj.roundTwoDemoTime = this.convertMinIntoSec(this.minute) + this.second;
              this.trailTestObj.roundTwoDemoTimeInMinSec = { minute: this.minute, second: this.second }
              this.popup.msg = 'Start test';

              this.trailTestObj.roundTwoDemoWrongCount = this.wrongCount;
              this.wrongCount = 0;

              this.masterAnswerSheetArray = this.trailTestSequence.roundTwo;
              this.currentActiveRound = 2;
              this.trailTestModel.show();
              this.title = 'Trail Test Round Two Demo';

            } else {
              this.trailTestObj.roundTwoWrongCount = this.wrongCount;
              this.wrongCount = 0;
              this.trailTestObj.roundTwoTime = this.convertMinIntoSec(this.minute) + this.second;
              this.trailTestObj.roundTwoTimeInMinSec = { minute: this.minute, second: this.second };
              this.trailTestObj.userAge = this.dataManipSrvc.age;
              // this.trailTestObj.roundTwoTestResult = this.checkTrailTestScoringPart2(this.dataManipSrvc.age, this.trailTestObj.roundTwoTime)
              // this.trailTestObj.testConclusions = this.testConclusions(this.trailTestObj.roundOneTestResult, this.trailTestObj.roundTwoTestResult)
              // this.finalReportModal.show()
              this.testFinish.emit(this.trailTestObj)
            }
        // console.log('Finish', this.trailTestObj);
          } else {
            item.active = 'active-box';

          }
          // this.leader(masterAns, value);
        } else {
          this.playBeepAudio()
        }
        // console.log(this.UserCorrectAnswerArray, masterInd,lastAns,masterAns,ansInd);

      } else if (this.masterAnswerSheetArray[0] == value) {
        this.UserCorrectAnswerArray[0] = value;
        item.active = 'active-box'
      } else {
        this.playBeepAudio()
      }
    }
    // console.log(item, this.UserCorrectAnswerArray);
  }
  playBeepAudio() {
    this.wrongCount++;
    // Assign a song time of zero
    this.audio.currentTime = 0;
    this.audio.play();
  }


  timer() {
    this.time = 0;     //  The default time of the timer
    this.mode = 1;     //    Mode: count up or count down ;count-up (1) or countdown (0)
    this.status = 0;    //    Status: timer is running or stope
    this.timer_id;    //    This is used by setInterval function
    this.wrongCount = 0;
  }
  // This method will render the time variable to hour:minute:second format
  generateTime() {
    let second = this.time % 60;
    let minute = Math.floor(this.time / 60) % 60;
    let hour = Math.floor(this.time / 3600) % 60;

    this.second = (second < 10) ? +'0' + second : second;
    this.minute = (minute < 10) ? +'0' + minute : minute;
    this.hour = (hour < 10) ? +'0' + hour : hour;
    // console.log('generateTime',hour,minute,second);
  }
  // this will start the timer ex. start the timer with 1 second interval timer.start(1000) 
  start = (interval = 1000) => {
    interval = (typeof (interval) !== 'undefined') ? interval : 1000;

    if (this.status == 0) {
      this.status = 1;
      this.timer_id = setInterval(() => {
        switch (this.mode) {
          default:
            if (this.time) {
              this.time--;
              this.generateTime();
              // if (typeof (callback) === 'function') callback(this.time);
            }
            break;

          case 1:
            if (this.time < 86400) {
              this.time++;
              this.generateTime();
              // if (typeof (callback) === 'function') callback(this.time);
            }
            break;
        }
      }, interval);
    }
  }
  // Reset the timer to zero or reset it to your own custom time ex. reset to zero second timer.reset(0)
  reset = (sec) => {
    sec = (typeof (sec) !== 'undefined') ? sec : 0;
    this.time = sec;
    this.generateTime();
  }
  //  Same as the name, this will stop or pause the timer ex. timer.stop()
  stop() {
    if (this.status == 1) {
      this.status = 0;
      clearInterval(this.timer_id);
    }
  }

  leader(id, id2) {
    let startEl = document.getElementById('line-' + id);
    let endEl = document.getElementById('line-' + id2);
// console.log(id, id2);

    return new LeaderLine(
      startEl,
      endEl, {
      endPlugOutline: false,
      animOptions: { duration: 3000, timing: 'linear' },
      size: 3,
      endPlugSize: 1,
      color: 'rgba(30, 130, 250, 0.5)'
    }
    );
  }
  convertMinIntoSec(min) {
    return (+min) * 60;
  }

  testConclusions(round1, round2) {
    const result = ["Good", "Average", "Low", "None"];
    const resultSynonym = ["Good", "Normal", "Poor", "None"];
    const roundOneResult = result.indexOf(round1);
    const roundTwoResult = result.indexOf(round2);
    return roundOneResult > roundTwoResult ? resultSynonym[roundOneResult] : resultSynonym[roundTwoResult];
  }

  checkTrailTestScoringPart1(age, sec): "Good" | "Average" | "Low" | "None" {
    if (age >= 8 && age < 25) {
      if (sec <= 28) {
        return 'Good';
      } else if (sec >= 29 && sec <= 34) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 25 && age < 35) {
      if (sec <= 29) {
        return 'Good';
      } else if (sec >= 30 && sec <= 35) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 35 && age < 60) {
      if (sec <= 31) {
        return 'Good';
      } else if (sec >= 32 && sec <= 37) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 60 && age < 65) {
      if (sec <= 34) {
        return 'Good';
      } else if (sec >= 35 && sec <= 40) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 65 && age < 45) {
      if (sec <= 39) {
        return 'Good';
      } else if (sec >= 40 && sec <= 45) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 65 && age < 85) {
      if (sec <= 55) {
        return 'Good';
      } else if (sec >= 56 && sec <= 61) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else {
      return 'None';
    }


  }

  checkTrailTestScoringPart2(age, sec): "Good" | "Average" | "Low" | "None" {
    if (age >= 8 && age <= 25) {
      if (sec <= 49) {
        return 'Good';
      } else if (sec >= 50 && sec <= 60) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age > 25 && age < 35) {
      if (sec <= 51) {
        return 'Good';
      } else if (sec >= 52 && sec <= 62) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 35 && age <= 44) {
      if (sec <= 59) {
        return 'Good';
      } else if (sec >= 60 && sec <= 70) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 45 && age < 55) {
      if (sec <= 64) {
        return 'Good';
      } else if (sec >= 65 && sec <= 75) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 55 && age < 70) {
      if (sec <= 69) {
        return 'Good';
      } else if (sec >= 70 && sec <= 80) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 70 && age < 75) {
      if (sec <= 84) {
        return 'Good';
      } else if (sec >= 85 && sec <= 95) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else if (age >= 75 && age < 85) {
      if (sec <= 102) {
        return 'Good';
      } else if (sec >= 103 && sec <= 113) {
        return 'Average';
      } else {
        return 'Low'
      }
    } else {
      return 'None';
    }


  }
}

